import script from "./AdminDownloadLogs.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminDownloadLogs.vue?vue&type=script&setup=true&lang=js"

import "./AdminDownloadLogs.vue?vue&type=style&index=0&id=fb15cdae&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb15cdae"]])

export default __exports__